import React from 'react';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from '@material-ui/core/Badge';
import MenuItemAnchor from './MenuItemAnchor';
import omit from 'lodash/omit';
import theme from '../../theme';

function isVisible(user) {
    return user.isAuthenticated;
}

class Toolbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = { open: false, notifications: [], isLoading: true };
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.fetchNotifications().then(
            notifications => this.setState({notifications, isLoading: false}),
            error => { console.error(error); }
        );
    }

    render() {
        if (!isVisible(this.props.user)) return null;

        return (<React.Fragment>
            {this.renderButton()}
            {this.renderMenu()}
        </React.Fragment>);
    }

    renderButton() {
        return (<this.props.component
            {...omit(this.props, 'user')}
            href="#"
            onClick={event => {
                event.preventDefault();
                this.setState({open: true});
                this.markNotificationsViewed();
            }}
            style={{
                ...this.props.style,
                paddingRight: theme.spacing.unit
            }}
        >
            {/* The ref won't work on the parent component. I don't know why. */}
            <div ref={this.ref}>
                {this.props.children || this.renderButtonIcon()}
            </div>
        </this.props.component>);
    }

    renderButtonIcon() {
        if (this.state.isLoading) return <NotificationsIcon />;

        const {notifications} = this.state;
        const unviewedNotifications = notifications.filter(({isViewed}) => !isViewed);

        if (unviewedNotifications.length) {
            return (<Badge badgeContent={unviewedNotifications.length} color="secondary">
                <NotificationsIcon />
            </Badge>);
        } else {
            return <NotificationsIcon />;
        }
    }

    renderMenu() {
        return (<Menu
            anchorEl={this.ref.current}
            open={this.state.open}
            onClose={() => this.setState({open: false})}
        >{this.renderMenuInner()}</Menu>);
    }

    renderMenuInner() {
        if (this.state.isLoading) {
            return <CircularProgress style={{margin: theme.spacing.unit * 2}} />;

        } else if (this.state.notifications.length === 0) {
            return <MenuItem>You have no notifications</MenuItem>;

        } else {
            return this.state.notifications.map(notification => (
                <MenuItem key={notification.id} style={{height: 'auto', maxWidth: theme.spacing.unit * 30, whiteSpace: 'normal'}}>
                    {<div dangerouslySetInnerHTML={{__html: notification.html}} />}
                </MenuItem>
            ));
        }
    }

    fetchNotifications() {
        if (!this.props.user.isAuthenticated) return Promise.resolve([]);

        return fetch('/social/notifications/popup/', {credentials: 'include'})
            .then(response => response.json());
    }

    markNotificationsViewed() {
        const {notifications} = this.state;

        const promise = Promise.all(notifications.map(notification =>
            fetch(`/social/notifications/${notification.id}/markviewed/`, {method: 'post'})
        ));

        promise.then(() => this.setState({
            notifications: notifications.map(notification =>
                ({...notification, isViewed: true})
            )
        }));

        promise.catch(error => { console.error(error); });
    }
}

Toolbar.defaultProps = { component: 'a' };

function HamburgerMenu(props) {
    if (!isVisible(props.user)) return null;

    return <Toolbar component={MenuItemAnchor} {...props}>{gettext('Notifications')}</Toolbar>;
}

export default { Toolbar, HamburgerMenu };
